/** @jsx jsx */
import { jsx } from '@theme-ui/core';
import Modal from 'react-modal';
import { ButtonGhost, IconUiClose } from '@uberall/zenit';

import styles from './index.module.css';
import Message from '../../../Message';
import { SelectionListItem } from '../../../../contexts/types';
import ModalContent from '../modal-content/modal-content';
import FooterButton from '../footer-button';

type ModalMobileProps = {
    title: string;
    subtitle: string;
    isLoading: boolean;
    isFetchingNextPage: boolean;
    showModal: boolean;
    items: SelectionListItem[];
    onAdd: (items: SelectionListItem[]) => void;
    onClose: () => void;
    onToggle: (id: string) => void;
    fetchNextPage: () => void;
};

const ModalMobile = ({
    items,
    title,
    subtitle,
    onAdd,
    onToggle,
    onClose,
    fetchNextPage,
    isFetchingNextPage,
    isLoading,
    showModal,
}: ModalMobileProps) => {
    return (
        <Modal
            isOpen={showModal}
            onRequestClose={onClose}
            className={styles.modal}
            contentLabel="Example Modal"
            overlayClassName={styles.modalOverlay}
        >
            <div className={styles.header}>
                <h2 className={styles.modalHeading}>
                    <Message code={title} />
                </h2>
                <ButtonGhost
                    onClick={onClose}
                    icon={<IconUiClose size="xsmall" />}
                    aria-label="Back"
                    sx={{ padding: 0 }}
                />
            </div>
            <ModalContent
                containerClassName={styles.contentContainer}
                items={items}
                onToggle={onToggle}
                subtitle={subtitle}
                fetchNextPage={fetchNextPage}
                isLoading={isLoading}
                isFetchingNextPage={isFetchingNextPage}
            />
            <div className={styles.footer}>
                <FooterButton items={items} onAdd={onAdd} />
            </div>
        </Modal>
    );
};

export default ModalMobile;
